export default [
  {
    path: "/sign",
    component: () => import("@/views/sign/index"),
    children: [
      {
        path: "home",
        component: () => import("@/views/sign/home"),
        meta: {
          title: "就餐记录"
        }
      },
    ]
  }
];


// WEBPACK FOOTER //
// ./src/router/sign.js